import clsx from 'clsx';
import Button from 'components/Button/Button';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type ITabs from './interfaces/ITabs';

import styles from './scss/Tabs.module.scss';

function Tabs({ data, activeTab, onClickTab }: Readonly<ITabs>) {
  return (
    <div className={styles.tabs}>
      {data?.map((item) => (
        <Button
          key={[item.id, item.name].join('-')}
          title={item.name}
          variant={BUTTON_VARIANT.ghost}
          onClick={() => onClickTab(item.id)}
          className={clsx(styles.tab, { [styles.active]: activeTab === item.id })}
        />
      ))}
    </div>
  );
}

export default Tabs;
